// extracted by mini-css-extract-plugin
export var link = "_to-0";